module.exports = __webpack_public_path__ + "a8018971d53c8a1bbde0e96babfd0287.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Mobilepay.png
// module id = 535
// module chunks = 0